import { Modal, Tabs } from 'antd';
import { useEffect, useState } from 'react';

import ModalMapLocation from 'components/Map/ModalMapLocation';
import { IRouteInfo } from 'interfaces/SaleLine';
import { toastError } from 'utils/constants/functions';
import CustomerList from './CustomerList';
import NewCustomer from './NewCustomer';
import Recommended from './Recommended';

interface Iprops {
  open: boolean;
  setOpen: any;
  searchId: any;
  routeInfo?: IRouteInfo;
  handleOK: (data: any) => Promise<void>;
  type?: any;
  implementationDate?: string;
}

export default function ModalAddCustomerToRoute(props: Iprops) {
  const {
    open,
    setOpen,
    searchId,
    routeInfo,
    implementationDate,
    handleOK,
    type = true,
  } = props;
  const [item, setItem] = useState<any>(undefined);
  const [newCustomer, setNewCustomer] = useState<any>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [openMap, setOpenMap] = useState(false);
  const [location, setLocation] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState<any>({
    area: [],
    system: [],
  });

  const handleCancel = () => {
    setOpen(false);
  };

  const items = [
    {
      label: 'Danh sách',
      key: '1',
      children: (
        <CustomerList
          setData={setData}
          setOpenMap={setOpenMap}
          setLocation={setLocation}
          searchId={searchId}
          newCustomer={newCustomer}
          setNewCustomer={setNewCustomer}
          type={type}
          customer={{ customer: item, setCustomer: setItem }}
          search={{ value: inputValue, setValue: setInputValue }}
        />
      ),
    },
    {
      label: 'Hệ thống đề xuất',
      key: '2',
      children: (
        <Recommended
          data={data.system}
          salePlaningId={searchId}
          routeInfo={routeInfo}
          setNewCustomer={setNewCustomer}
          implementationDate={implementationDate}
          setData={setData}
          setOpenMap={setOpenMap}
          setLocation={setLocation}
        />
      ),
    },
    {
      label: 'Khách hàng mới chung khu vực',
      key: '3',
      children: (
        <NewCustomer
          data={data.area}
          salePlaningId={searchId}
          routeInfo={routeInfo}
          setNewCustomer={setNewCustomer}
          setData={setData}
          setOpenMap={setOpenMap}
          setLocation={setLocation}
        />
      ),
    },
  ];

  async function handleCheckOK(newCustomer: any) {
    if (loading) return;
    setLoading(true);

    if (newCustomer.length == 0) {
      toastError('Vui lòng chọn khách hàng');
      setLoading(false);
      return;
    }

    try {
      await handleOK(newCustomer);
    } catch (error) {
      //
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setNewCustomer([]);
    setItem(undefined);
    setInputValue('');
  }, [open]);

  return (
    <>
      <Modal
        title={
          <div
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            {type != 'TeamSale'
              ? 'Thêm khách hàng vào tuyến'
              : 'Thêm khách hàng vào đội'}
          </div>
        }
        open={open}
        width={'68%'}
        okText="Thêm"
        cancelText="Huỷ"
        onOk={() => handleCheckOK(newCustomer)}
        onCancel={handleCancel}
        style={{
          top: '5%',
        }}
        className="h-max"
        okButtonProps={{
          loading,
        }}
      >
        {type == true ? (
          <Tabs
            className="custom-tabs"
            defaultActiveKey="1"
            tabBarGutter={0}
            centered
            items={items.map((tab) => ({
              label: tab.label,
              key: tab.key,
              children: tab.children,
            }))}
          />
        ) : (
          <CustomerList
            setData={setData}
            setOpenMap={setOpenMap}
            setLocation={setLocation}
            searchId={searchId}
            newCustomer={newCustomer}
            setNewCustomer={setNewCustomer}
            type={type}
            customer={{ customer: item, setCustomer: setItem }}
            search={{ value: inputValue, setValue: setInputValue }}
          />
        )}
      </Modal>
      <ModalMapLocation
        title={'Xem chi tiết'}
        open={openMap}
        setOpen={setOpenMap}
        center={{
          // ...item,
          lat: parseFloat(location?.latitude) || null,
          lng: parseFloat(location?.longitude) || null,
        }}
        // updateLocation={updateLocation}
      />
    </>
  );
}
